<ng-template #choicesiterator let-choices>
    @if (choices) {
        <div class="row">
            @for (k of objectKeys(choices); track k) {
                @if (choices[k].choices) {
                    <div (click)="checkGroup(choices[k].choices)" class="option label">
                        @if (multiple) {
                            <input type="checkbox" [checked]="isSelectedGroup(choices[k].choices)" />
                        }
                        <i class="fa {{ choices[k].label }}"></i>
                    </div>
                    <div class="row">
                        <ng-template [ngTemplateOutlet]="choicesiterator" [ngTemplateOutletContext]="{ $implicit: choices[k].choices }"> </ng-template>
                    </div>
                }
                @if (!choices[k].choices) {
                    <div
                        (click)="checkValue(choices[k].value)"
                        class="col-6 col-sm-4 col-md-3 col-lg-2 option choice justify-content-center"
                        [class.checked]="isSelected(choices[k].value)"
                        [class.errors]="view.vars.errors.length"
                    >
                        <div class="inner1 py-3">
                            <i [class]="choices[k].value?.icon + ' fa-fw fa-5x'"></i>
                            @if (!choices[k].value?.icon?.path) {
                                <h5 class="font-weight-bold my-2">{{ choices[k].label }}</h5>
                            }
                        </div>
                        @if (choices[k].value?.icon?.path) {
                            <h5 class="font-weight-bold my-2">{{ choices[k].label }}</h5>
                        }
                    </div>
                }
            }
        </div>
    }
</ng-template>

<ng-template [ngTemplateOutlet]="choicesiterator" [ngTemplateOutletContext]="{ $implicit: choices }"> </ng-template>
